﻿<template>
  <div id="app">
    <!---->
    <div class="post">
      <Header-el></Header-el>
      <div class="searchquestion">
        <div class="clearfix searcharea">
          <input type="text" v-model="d_helpsearchval" placeholder="请输入你想咨询的问题......" @keyup.enter="helplistbtn" autofocus="autofocus" class="fl" />
          <button class="fl" @click="helplistbtn">搜 索</button>
          <div class="searchresult" v-show="d_searchhelpshow">
            <ul class="searchlist" style="display: none;" v-show="d_searchheldata.length>0">
            <li v-for="(helplist,helpindex) in d_searchheldata" v-bind:key="helpindex">
              <a :href="'/helpshow/'+helplist.ID" v-text="helplist.Title"></a>
            </li>
            </ul>
            <span style="display:none;" v-show="d_searchheldata.length==0">没有找到相关问题哦。。。</span>
          </div>
        </div>
      </div>
      <div class="bottomcontent">
        <div class="content clearfix">
          <div class="leftpart fl">
            <div class="leftmenu">
              <!--<h5>新手引导</h5>-->
              <!--<ul class="guide">-->
                <!--<li>-->
                  <!--<a href="https://www.kaishiba.com/special/mactive/about_index" title="关于我们">关于我们</a>-->
                <!--</li>-->
                <!--<li>-->
                  <!--<a href="https://blog.kaishiba.com/project-guide" title="发起人指南">发起人指南</a>-->
                <!--</li>-->
                <!--<li>-->
                  <!--<a href="https://blog.kaishiba.com/partner-guide" title="共建人指南">共建人指南</a>-->
                <!--</li>-->
              <!--</ul>-->
              <h5>使用指南</h5>
              <div class="guideItem" v-for="(category,cateindex) in categoryData" v-bind:key="category.ID">
                <h6 v-on:click="categoryactive=category.ID;category.IsEnable = !category.IsEnable">
                  <span>{{category.Name}}</span>
                  <div>
                    <img src="http://images.kaishiba.com/20180226bzzx9.png" class="iconminus" v-show="!category.IsEnable" />
                    <img src="http://images.kaishiba.com/20180226bzzx10.png" class="iconplus" v-show="category.IsEnable" />
                  </div>
                </h6>
                <ul v-show="!category.IsEnable">
                  <li v-for="(help,index) in category.helplistData" v-bind:key="index" @click="d_helplistindex=help.ID">
                    <a :href="'/helpshow/'+help.ID" :title="help.Name" :class="{'active':help.Isactive}">{{help.Title}}</a>
                    <!---->
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="rightpart fr">
            <div class="postcontent">
              <h4 class="title">{{helpcontent.Title}}</h4>
              <div class="contenthtml" v-html="helpcontent.Content"></div>
            </div>
            <div class="solvedfeedback">
              <div class="seperateline">
                <span>以上方案是否解决了您的问题？</span>
              </div>
              <div class="container">
                <div class="feedbackoptions clearfix">
                  <div class="fl" v-show="d_feedshow" @click="d_feedshow=false;d_frshow=true;d_flshow=false">
                    <img src="http://images.kaishiba.com/20180226bzzx1.png" />
                    <span>已解决</span>
                  </div>
                  <div class="fr" v-show="d_feedshow" @click="d_feedshow=false;d_frshow=false;d_flshow=true">
                    <img src="http://images.kaishiba.com/20180226bzzx2.png" />
                    <span>未解决</span>
                  </div>
                </div>
                <div class="feedbackresult" style="display: none;" v-show="d_frshow">
                  <img src="http://images.kaishiba.com/20180226bzzx3.png" />
                  <span>已解决 I 感谢您的反馈，我们会继续努力哒！</span>
                </div>
                <div class="feedbackresult" style="display: none;" v-show="d_flshow">
                  <img src="http://images.kaishiba.com/20180226bzzx4.png" />
                  <span>未解决 I 感谢您的反馈，我们会尽快改进的！</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul id="nav-share" class="nav-share" style="bottom: 100px; right: 80px;">
        <li class="s-phone">
          <a href="javascript:;"></a>
          <div class="s-phone-hover">
            <p class="sph-t">客服热线（10:00 -20:00）</p>
            <p class="sph-p">13919392393</p>
          </div>
        </li>
        <li class="s-wechat">
          <a href="javascript:;"></a>
          <div class="s-wechat-hover">
            <img width="100%" height="100%" src="/images/qrcode.jpg" alt="wechat" />
          </div>
        </li>
        <li class="s-wechat-mini"><a href="javascript:;"></a>
          <div class="s-wechat-mini-hover"><img width="100%" height="100%" src="/images/littlecode.jpg"
                                                alt="wechat"></div>
        </li>
        <li class="s-sina">
          <a href="//weibo.com/beginow" target="_blank"></a>
        </li>
        <!---->
      </ul>
    </div>
  </div>
</template>
<style scoped>
@import url("../css/helpshow.css");
</style>
<script>
import Header from "../components/header";
import Footer from "../components/footer";
export default {
  name: "app",
  components: {
    "Header-el": Header,
    "Footer-el": Footer
  },
  data() {
    return {
      helpcontent: {},
      helplistData: [],
      helpFilter: {},//ParentID:{Value:'aee46eb0-1b61-4b95-a924-e8d908c91f46'}
      categoryData: [],
      categoryactive: "ed3a1049-c543-43fc-9a03-182698ad6c54",
      d_activelistindex:0,
      d_helplistindex:-1,
      d_helpsearchval:'',
      d_searchhelpshow:false,
      d_searchheldata:[],
      d_frshow:false,
      d_flshow:false,
      d_feedshow:true
    };
  },
  watch:{
    d_helpsearchval (val) {
      var t = this
      if(val=="") {
        t.d_searchhelpshow = false
        t.d_searchheldata = []
      }
    }
  },
  methods: {
    init:function() {
      // var url = location.href
      // var urlcatedata = url.slice(31)
      // if(urlcatedata!="") {
      //   this.categoryactive = urlcatedata
      //   this.d_helplistindex = urlcatedata
      //   console.log(this.categoryData)
      // }

    },
    //帮助模糊搜索
    helplistbtn:function() {
      var t = this
      t.d_searchhelpshow = true
       t.helpFilter= {
        Pager: { PageNumber: 1, PageSize:100 },
        CategoryID: { Value:null },
        title:{Value:t.d_helpsearchval,Mode:0}
      }
      T.post("/api/help/list", this.helpFilter, function(data) {
          t.d_searchheldata = data.Results
      })
    },
    loadcontent: function() {
      const id = this.$route.params.id;

      var _self = this;
      T.get("/api/help/" + id, function(data) {

        if (data.Success) {
          _self.helpcontent = data.Data;
        }
      });
    },
    loadList: function(categoryID) {
      var _self = this;
      this.helpFilter.categoryID = { Value: categoryID };
      T.post("/api/help/list", this.helpFilter, function(data) {
        _self.helplistData = data.Results;
      });
    },
    loadCategory: function() {
      var _self = this;
      T.get("/api/help/category/get", function(data) {
        _self.categoryData = data.Data;
        _self.categoryData.forEach(function(val,ind) {

          T.post("/api/help/list",{ categoryID:{Value: val.ID} }, function(data) {

            val.helplistData = data.Results;
            val.helplistData.forEach(function(resval,resind) {
              resval.Isactive = false
              if(resval.ID == location.href.slice(31)) {

                val.IsEnable = false
                resval.Isactive = true
                return;
              }
            })

          });
        })
      });




    }
  },
  created() {
    this.loadcontent();

    this.loadCategory();
  },
  mounted() {

    this.init()
    var t =this

  }
};
</script>
